import { FormFieldProps } from "../index";
import { readValue } from "../Utils";
import Strings from "@my-dld/assets/strings";

export function NonZeroValidator<T, XT>( props: FormFieldProps<T, XT> ): string | null {
	let cValue = readValue( props );
	if ( cValue != null ) {
		const n = Number( cValue );
		if ( n === 0 ) {
			return Strings.required;
		}
		return null;
	}
	return Strings.required;
}
